import { render } from "./back-to-previous-page.vue?vue&type=template&id=7deb2bbb&ts=true"
import script from "./back-to-previous-page.vue?vue&type=script&lang=ts"
export * from "./back-to-previous-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__